export default {
  BTN_POST: 'Post',
  BTN_SAVE: 'Save changes',
  BTN_CANCEL: 'Cancel',
  BTN_DELETE: 'Delete',
  BTN_ADD: 'Add new',
  BTN_MAKE_IN_ACTIVE: 'Make inactive',
  ALL_FIELDS_REQUIRED: '* All starred fields are required.',
  STATUS_ACTIVE: 'Active',
  STATUS_INACTIVE: 'Inactive',
}
